import { render, staticRenderFns } from "./PayoutsPendingMiniCard.vue?vue&type=template&id=1019fc2e&"
import script from "./PayoutsPendingMiniCard.vue?vue&type=script&lang=js&"
export * from "./PayoutsPendingMiniCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports